module.exports = __webpack_public_path__ + "img/u2999.c7af2982.png";